import $ from 'jquery';
import 'slick-carousel';

function slider_with_custom_paging($slider, arrows) {
	let $slides = $slider.find('.slider__slides');

	if ( arrows == undefined ) {
		arrows = false;
	}

	$slides.slick({
		dots: true,
		arrows: arrows,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		centerMode: false,
		variableWidth: false,
		adaptiveHeight: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
		customPaging : function(slider, i) {
			var $slideImage = $(slider.$slides[i]).find('.slider__slide-image');
			$slideImage.html('<span class="page_num"><span class="current__slide">' + (i + 1) + '</span>/<span>' + $(slider.$slides).length + '</span></span>');
		},
		responsive: [
			{
				breakpoint: 768,
				settings: {
					adaptiveHeight: true,
				}
			}
		]
	});
}

export default slider_with_custom_paging;
